
import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Captcha from "units/auth/components/turnstile";
import axiosInstance from "api/axiosInstance";

const schema = yup.object().shape({
  name: yup.string().required("نام و نام خانوادگی الزامی است."),
  phone: yup
    .string()
    .matches(/^09\d{9}$/, "شماره تماس باید با 09 شروع شود و 11 رقم باشد.")
    .required("شماره تماس الزامی است."),
  email: yup.string().email("ایمیل وارد شده معتبر نیست.").required("ایمیل الزامی است."),
  message: yup
    .string()
    .max(10000, "تعداد کاراکتر پیام نمی‌تواند بیش از 10000 باشد.")
    .nullable(),
});

export default function VIPplan() {
  const [captchaToken, setCaptchaToken] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    if (!captchaToken) {
      toast.error("لطفاً کپچا را تکمیل کنید.");
      return;
    }
    try {
      setIsSubmitting(true);
      const result = await axiosInstance.post("/public/feedback", {
        ...data,
        captchaToken,
      });
      if (result.data.ok) {
        toast.success("پیام شما با موفقیت ثبت شد.");
        setSuccessMessage("✅ پیام شما ثبت شد و به زودی بررسی خواهد شد.");
        reset();
        setCaptchaToken("");
      } else {
        toast.error(result.data.error || "خطایی رخ داده است.");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error(error.response?.data?.error || "خطا در ارسال پیام.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative bg-white px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl text-center">
        <h1 className="text-[50px] font-yekan font-bold text-[#1f3e39] mb-4">
          طرح ویژه
        </h1>
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 lg:grid-cols-2 gap-10  items-start mb-32  justify-center">
        {/* متن سمت راست */}
        <div className="p-6 mx-auto">
          <h2 className="text-[25px] sm:text-[36px] font-bold text-yellow-400 mb-9 mt-10 ">
            آماده‌ای برای رشد کسب‌وکارت؟ 
          </h2>
          <p className="text-gray-700 leading-relaxed text-lg">
            هر کسب‌ وکار منحصر     به ‌فرد، یک دستیار ویژه، <br />
            اگر به طرحی فراتر از طرح های فعلی نیاز داری،{" "}
            <br />
            <span className="font-semibold text-[#1f3e39] text-[20px]">
              ما رایابات را مخصوص تو می‌سازیم.
            </span> <br />
            برای شروع فقط کافیه فرم روبرو را پر کنی...
          </p>
        </div>

        {/* فرم سمت چپ */}
        <div className="bg-white rounded-3xl shadow-lg ring-1 ring-gray-200 p-6 sm:p-8 max-w-md mx-auto w-full">
          <h2 className="text-xl font-bold text-center text-[#f7b400] mb-6">
            فرم طرح اختصاصی
          </h2>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
            {/* نام */}
            <div>
              <input
                type="text"
                placeholder="نام و نام خانوادگی"
                {...register("name")}
                className={`w-full rounded-xl border px-4 py-2.5 text-gray-800 focus:outline-none focus:ring-2 ${errors.name
                    ? "border-red-400 focus:ring-red-400"
                    : "border-gray-300 focus:ring-[#f7b400]/40"
                  }`}
                dir="rtl"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
              )}
            </div>

            {/* تلفن */}
            <div>
              <input
                type="tel"
                placeholder="شماره تماس"
                {...register("phone")}
                className={`w-full rounded-xl border px-4 py-2.5 text-gray-800 focus:outline-none focus:ring-2 ${errors.phone
                    ? "border-red-400 focus:ring-red-400"
                    : "border-gray-300 focus:ring-[#f7b400]/40"
                  }`}
                dir="rtl"
              />
              {errors.phone && (
                <p className="text-red-500 text-sm mt-1">{errors.phone.message}</p>
              )}
            </div>

            {/* ایمیل */}
            <div>
              <input
                type="email"
                placeholder="ایمیل"
                {...register("email")}
                className={`w-full rounded-xl border px-4 py-2.5 text-gray-800 focus:outline-none focus:ring-2 ${errors.email
                    ? "border-red-400 focus:ring-red-400"
                    : "border-gray-300 focus:ring-[#f7b400]/40"
                  }`}
                dir="rtl"
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
              )}
            </div>

            {/* پیام */}
            <div>
              <textarea
                placeholder="پیام شما (اختیاری)"
                {...register("message")}
                rows={4}
                className={`w-full rounded-xl border px-4 py-2.5 text-gray-800 focus:outline-none focus:ring-2 ${errors.message
                    ? "border-red-400 focus:ring-red-400"
                    : "border-gray-300 focus:ring-[#f7b400]/40"
                  }`}
                dir="rtl"
              />
              {errors.message && (
                <p className="text-red-500 text-sm mt-1">{errors.message.message}</p>
              )}
            </div>

            {/* کپچا */}
            <div className="flex justify-center my-3">
              <Captcha tokenSetter={setCaptchaToken} />
            </div>

            {/* دکمه ارسال */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 ${isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#f7b400] hover:bg-[#f7a500]"
                }`}
            >
              {isSubmitting ? "در حال ارسال..." : "ارسال پیام"}
            </button>

            {/* {successMessage && (
              <p className="mt-3 text-green-600 font-medium text-center animate-fade-in">
                {successMessage}
              </p>
            )} */}
          </form>
        </div>
      </div>
    </div>
  );
}
